import * as axios from '../../axios-extended'
import * as t from 'io-ts'
import { NewCustomer, Query } from './types'
import { Customer } from '../../types'

const apiUrl = '/prosperbill/api'

const Customers = t.type({ count: t.number, data: t.array(Customer) })

export const getPayers = (
  organization: string,
  { page = 0, itemsPerPage = 10, sort = ['id', 'desc'] }: Partial<Query>,
  cancelToken?: axios.CancelToken
) =>
  axios.get(`${apiUrl}/customers/${organization}`, {
    cancelToken,
    params: {
      page,
      size: itemsPerPage,
      sort: `${sort[0]},${sort[1]}`,
    },
    decoder: Customers,
  })

export const addPayer = (
  organization: string,
  payer: NewCustomer,
  cancelToken?: axios.CancelToken
) =>
  axios.post(`${apiUrl}/customers/${organization}`, payer, {
    cancelToken,
    decoder: Customer,
  })

export const editPayer = (
  organization: string,
  p: Customer,
  cancelToken?: axios.CancelToken
) =>
  axios.put(`${apiUrl}/customers/${organization}`, p, {
    cancelToken,
    decoder: Customer,
    encoder: Customer,
  })

export const deletePayer = (
  organization: string,
  id: number,
  cancelToken?: axios.CancelToken
) =>
  axios.delete_(`${apiUrl}/customers/${organization}/${id}`, {
    cancelToken,
    decoder: t.unknown,
  })

export const getPayerByEmailOrPhonenumber = (
  organization: string,
  email?: string,
  phone?: string,
  cancelToken?: axios.CancelToken
) =>
  axios.get(`${apiUrl}/customers/${organization}/customer`, {
    cancelToken,
    params: { email, phone },
    decoder: Customer,
  })

export const searchPayers = (
  organization: string,
  query: string,
  cancelToken?: axios.CancelToken
) =>
  axios.get(`${apiUrl}/customers/${organization}/customers`, {
    cancelToken,
    params: { query },
    decoder: t.array(Customer),
  })

export const getPayerByID = (id: number, cancelToken?: axios.CancelToken) =>
  axios.get(`${apiUrl}/customers/${id}`, { cancelToken, decoder: Customer })
